import { render, staticRenderFns } from "./OrmSendQuoteModal.vue?vue&type=template&id=2d33343e&scoped=true"
import script from "./OrmSendQuoteModal.vue?vue&type=script&lang=js"
export * from "./OrmSendQuoteModal.vue?vue&type=script&lang=js"
import style0 from "./OrmSendQuoteModal.vue?vue&type=style&index=0&id=2d33343e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33343e",
  null
  
)

export default component.exports